module.exports = __webpack_public_path__ + "media/icons/pro-badge-small-2f3269b3.svg";